import { Typography, Tag, TagColor } from '@shipengine/giger';
import { Currency } from '@packlink/packlink-sdk';
import { getInsuranceCardTitleStyles } from './InsuranceCardHeaderStyles.js';
import { useTranslation } from '@packlink/translation-provider';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const InsuranceCardHeader = _ref => {
  let {
    currency,
    price,
    title,
    isRecommended
  } = _ref;
  const hasPrice = price !== undefined;
  const formattedPrice = Currency.format(price !== null && price !== void 0 ? price : 0, currency);
  const {
    t
  } = useTranslation();
  return jsxs("header", {
    children: [jsxs("div", {
      css: getInsuranceCardTitleStyles,
      children: [jsx(Typography, {
        variant: "body2",
        bold: true,
        children: title
      }), isRecommended && jsx(Tag, {
        color: TagColor.INFO,
        children: t('insurance-card.header.recommended-tag')
      })]
    }), hasPrice && jsx(Typography, {
      variant: "body1",
      children: formattedPrice
    })]
  });
};

export { InsuranceCardHeader };
//# sourceMappingURL=InsuranceCardHeader.js.map
